module.exports = __webpack_public_path__ + "static/img/gutachten.74a3c4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/gutachten.png
// module id = IO1Q
// module chunks = 1